{
  "name": "frontend",
  "version": "1.0.0",
  "schemaVersion": "1.0.0",
  "type": "module",
  "private": true,
  "scripts": {
    "start": "yarn prebuild && parcel public/index.html --no-cache",
    "copy:locales": "cp -r public/locales dist",
    "prebuild": "rm -rf dist && mkdir dist && yarn copy:locales && cp public/ping.txt dist/",
    "build": "yarn prebuild && parcel build public/index.html --public-url ./ && yarn postbuild",
    "postbuild": "yarn tsx build-sw.ts",
    "serve": "serve dist -l 3000",
    "check:types": "tsc --noemit"
  },
  "dependencies": {
    "@automatarium/jflap-translator": "1.0.0",
    "@automatarium/simulation": "2.0.0",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "^9.28.0",
    "@msgpack/msgpack": "^2.8.0",
    "@parcel/transformer-typescript-types": "^2.15.2",
    "axios": "^0.30.0",
    "csstype": "^3.1.3",
    "dayjs": "^1.11.13",
    "globals": "^16.2.0",
    "goober": "^2.1.16",
    "i18next": "^23.16.8",
    "i18next-http-backend": "^3.0.2",
    "immer": "^9.0.21",
    "lodash.clonedeep": "^4.5.0",
    "lodash.groupby": "^4.6.0",
    "lucide-react": "^0.515.0",
    "prop-types": "^15.8.1",
    "react": "^17.0.2",
    "react-a11y-dialog": "^6.2.0",
    "react-dom": "^17.0.2",
    "react-hook-form": "^7.57.0",
    "react-i18next": "^14.1.3",
    "react-lottie-player": "^2.1.0",
    "react-markdown": "^8.0.7",
    "react-resizable": "^3.0.5",
    "react-router-dom": "^6.30.1",
    "typescript": "^4.9.5",
    "workbox-precaching": "^7.3.0",
    "zustand": "^4.5.7"
  },
  "devDependencies": {
    "@parcel/packager-raw-url": "2.16.0",
    "@parcel/transformer-inline-string": "^2.15.2",
    "@parcel/transformer-webmanifest": "2.16.0",
    "@types/lodash.groupby": "^4.6.9",
    "@types/node": "^20.19.0",
    "@types/react": "^18.3.23",
    "assert": "^2.1.0",
    "browserify-zlib": "^0.2.0",
    "buffer": "^6.0.3",
    "events": "^3.3.0",
    "glob": "^11.0.3",
    "parcel": "^2.15.2",
    "process": "^0.11.10",
    "serve": "^14.2.4",
    "stream-browserify": "^3.0.0",
    "tsx": "^4.20.6",
    "util": "^0.12.5",
    "workbox-build": "^7.3.0"
  }
}
